/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import toString from 'lodash/toString';
import { Icon, SecurityHelper } from 'sarsaparilla';

export default class AvailabilityCell extends React.Component {
    static propTypes = {
        isWalkup: PropTypes.bool,
        isLottery: PropTypes.bool,
        isGroupQuota: PropTypes.bool,
        total: PropTypes.number,
        count: PropTypes.number,
        isSelected: PropTypes.bool,
        selectedGroupSize: PropTypes.number,
        onSelectToggle: PropTypes.func,
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { total } = this.props;
        let displayCount = toString(this.props.count);
        let label = `No online reservations available`;
        if (this.props.count >= 99) {
            displayCount = `99+`;
        }
        if (this.props.isSelected) {
            label = `Groups: ${displayCount} out of ${total}`;
            return (
                <td className="selected">
                    <div className="rec-full-button-wrap">
                        <button
                            className="rec-availability-date selected"
                            onClick={this.props.onSelectToggle}
                            type="button"
                        >
                            <div className="rec-availability-hint" aria-label={label} />
                            <Icon iconName="check" />
                        </button>
                    </div>
                </td>
            );
        }
        if (this.props.isLottery) {
            label = [
                'This day is being managed by the lottery',
                'Please refer to important dates for application process',
            ].join('\u000A');
            return (
                <td className="lottery">
                    <div className="rec-full-button-wrap">
                        <button disabled className="rec-availability-date" type="button">
                            <div className="rec-availability-hint" aria-label={label} />L
                        </button>
                    </div>
                </td>
            );
        }
        if (SecurityHelper.isCommercialAccount()) {
            label = `Groups: ${displayCount} out of ${total}`;
            return (
                <td className="unavailable">
                    <div className="rec-availability-hint" aria-label={label} />
                    {displayCount}
                </td>
            );
        }
        if (
            this.props.count &&
            this.props.count > 0 &&
            (this.props.count >= this.props.selectedGroupSize || this.props.isGroupQuota)
        ) {
            label = `Groups: ${displayCount} out of ${total}`;
            return (
                <td className="available">
                    <div className="rec-full-button-wrap">
                        <button
                            className="rec-availability-date"
                            onClick={this.props.onSelectToggle}
                            type="button"
                        >
                            {displayCount}
                            <div className="rec-availability-hint" aria-label={label} />
                        </button>
                    </div>
                </td>
            );
        }
        if (this.props.count && !this.props.isWalkup) {
            label = `No online reservations available`;
            return (
                <td className="unavailable">
                    <div className="rec-availability-hint" aria-label={label} />
                    {displayCount}
                </td>
            );
        }
        if (this.props.isWalkup) {
            label = ['Walkup', 'This is available at the facility on the day of'].join(
                '\u000A'
            );
            return (
                <td className="walk-up">
                    <div className="rec-full-button-wrap">
                        <button disabled className="rec-availability-date" type="button">
                            W
                            <div className="rec-availability-hint" aria-label={label} />
                        </button>
                    </div>
                </td>
            );
        }
        return (
            <td className="unavailable">
                <div className="rec-availability-hint" aria-label={label} />
                {displayCount}
            </td>
        );
    }
}
